import React, { useEffect, useState } from "react";
import SupportMessage from "./SupportMessage";
import PrivateApi from "../../services/PrivateApiService";
import { Spinner } from "react-bootstrap";
import TicketStatus from "./TicketStatus";
import { useQuery } from "react-query";

/**
 * Message Container
 * 
 * container of all messages
 * 
 * @param {selectedTicket} props id of first ticket in list, to geather Messages
 * @param {setDate} props setter string date of message in view
 * @param {setIsEnergo} props setter bool if message is from energo or not
 * @param {updateMessages} props bool if messages has been updated
 * @param {setUpdateMessages} props setter bool set to false when new messages geathered
 *  
 * @returns gui
 * 
 * TODO: send only attachments which are connected to message, not all of them
 */
const MessageContainer = (props) => {

    const API = new PrivateApi(); // API
    const [attachments, setAttachments] = useState([]); // Attachments
    const [ticketData, setTicketData] = useState([]);

    
    const {data, error, isLoading} = useQuery(
        ["GET_TICKET_MESSAGES_QUERY", props.selectedTicket.id], 
        () =>  API.get_TicketDetails(props.selectedTicket.id), 
        {staleTime: 10000}
    );

    useEffect(() => {
        if (data !== undefined) {
            props.setDate("");
            props.setMessages(data.data.messages);
            setAttachments(data.data.attachments);
        }
    }, [data])


    // effect when selected ticket changes
    useEffect(() => {
        //GetTicketMessages();
        setTicketData([]);

        if (props.selectedTicket.description.includes('<tbody>')) {
            var table_str = props.selectedTicket.description.split('<tbody>')[1];
            const rows = table_str.split('<tr>').filter(Boolean);
    
            let extractedData = [];
            let extractedDict = {}
            rows.forEach((row) => {
                const matches = row.match(/<td>(.*?)<\/td>/g);
                if (matches && matches.length >= 2) {
                    const key = matches[0].replace(/<td>|<\/td>/g, '').trim();
                    const value = matches[1].replace(/<td>|<\/td>/g, '').trim();
                    extractedDict[key] = value;
                    if (key === "") {
                        extractedData.push(extractedDict);
                        extractedDict = {};
                    }
                }
            });
            setTicketData(extractedData);
        }

    }, [props.selectedTicket])


    // effect when updateMessages changes
    useEffect(() => {
        if (props.updateMessages) {
            //GetTicketMessages();
            props.setUpdateMessages(false);
        }
    }, [props.updateMessages]);


    // if data is loading
    if (isLoading) return <div style={{width: "100%", marginLeft: "50%", marginTop: "50px"}}>
            <Spinner animation="grow" className="text-energo"/>
            <Spinner animation="grow" className="text-energo"/>
            <Spinner animation="grow" className="text-energo"/>
        </div>;

    // if error by data fetching
    if (error) return <div style={{width: "100%", marginLeft: "50%", marginTop: "50px"}}>
        <p className="text-danger">Es ist ein Fehler aufgetreten. Versuchen Sie später erneut.</p>
    </div>
    

    // GUI
    return (
        <div className="mt-3">
            <div className="ticket-info" key="message-container">
                <TicketStatus type="created" creator={props.selectedTicket.create_uid[0] === 13? 'customer':'energo'} key={`created-${props.selectedTicket.id}`} ticket={props.selectedTicket} data={ticketData !== undefined? ticketData[0] : undefined} />

                {ticketData && ticketData.length > 0 ? (
                    <>
                        {ticketData[0]['Gebäude id'] !== undefined? 
                            <TicketStatus type="building" ticket={props.selectedTicket} data={ticketData[0]} key={`gebäude-${ticketData[0]['Gebäude id']}`} />
                        :null}

                        {ticketData[0]['Anlage id'] !== undefined ?
                            <TicketStatus type="anlage" ticket={props.selectedTicket} data={ticketData[0]} key={`anlage-${ticketData[0]['Anlage id']}`} />
                        :null}

                        {ticketData[0]['Fehlende Abrechnung'] !== undefined ?
                            <TicketStatus type="missingInvoice" ticket={props.selectedTicket} data={ticketData[0]} key={`missingInvoice-${props.selectedTicket.id}`} />
                        :null}

                        {ticketData[0]['Aktueller Betrag'] !== undefined ?
                            <TicketStatus type="paymentChange" data={ticketData[0]} key={`paymentChange-${props.selectedTicket.id}`} />
                        :null}

                        {props.selectedTicket.name.includes('Notfall')?
                            <TicketStatus type="emergency" key={`emergencyy-${props.selectedTicket.id}`} />
                        :null}

                        {props.selectedTicket.x_support_elv_id !== undefined && props.selectedTicket.x_support_elv_id.length > 0 ?
                            <TicketStatus type="elv" ticket={props.selectedTicket} key={`elv-${props.selectedTicket.x_support_elv_id[0]}`} />
                        : null}
                        
                        {ticketData[1] !== undefined && ticketData[1]['Rechnung von'] !== undefined ?
                            ticketData.map(data => (
                                data['Rechnung von'] !== undefined ?
                                    <TicketStatus type="invoice" data={data} />
                                :null
                            ))
                        :null}


                        
                    </>
                ):null}
            </div>

            {!isLoading && props.messages.length > 0 ?
                props.messages.map(m => (
                    <SupportMessage key={`comment-${m.id}`} message={m} attachments={attachments} setDate={props.setDate} setIsEnergo={props.setIsEnergo} />
                ))
                :
                !isLoading && props.messages.length === 0 ?
                    <p className="text-center">Keine Nachrichten</p>
                    :
                    isLoading ?
                        <div className="text-center">
                            <Spinner className="text-energo" animation="grow" /> &nbsp;
                            <Spinner className="text-energo" animation="grow" /> &nbsp;
                            <Spinner className="text-energo" animation="grow" />
                        </div>
                        :
            null}
            {props.selectedTicket.stage_id[1] === "Erledigt"? 
                <div className="ticket-info-closed">
                    <TicketStatus key={`closed-${props.selectedTicket.id}`} ticket={props.selectedTicket} type="closed" />
                </div>
            :null}
        </div>
    )
}

export default MessageContainer;